var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getTenantSettingsStatus == "success"
    ? _c(
        "div",
        { attrs: { id: "root" } },
        [
          _c(
            "el-container",
            [
              _c(
                "el-header",
                { attrs: { height: "auto" } },
                [
                  _c("router-link", { attrs: { to: "/" } }, [
                    _c("div", { staticClass: "logo" })
                  ]),
                  _vm._v(" "),
                  _vm.settings.back_button_link
                    ? _c(
                        "a",
                        {
                          staticClass: "back-to-site-button",
                          attrs: { href: _vm.settings.back_button_link }
                        },
                        [
                          _vm.settings.back_button_image_url
                            ? _c("img", {
                                attrs: {
                                  src: _vm.settings.back_button_image_url
                                }
                              })
                            : _vm._e(),
                          _vm._v(
                            _vm._s(
                              _vm.settings.back_button_text || "Back to website"
                            )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getSessionStatus == "success"
                    ? _c(
                        "div",
                        { staticClass: "header-controls" },
                        [
                          _c("el-button", {
                            staticClass: "toggle-header-controls",
                            attrs: {
                              type: "primary",
                              icon: "el-icon-user",
                              circle: ""
                            },
                            on: { click: _vm.toggleHeaderControls }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class: {
                                "header-controls-content": true,
                                visible: _vm.showHeaderControls
                              }
                            },
                            [
                              !_vm.user
                                ? _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "account",
                                          params: { redirect: _vm.$route.name }
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        { attrs: { type: "primary" } },
                                        [_vm._v("Login / Register")]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.user
                                ? _c(
                                    "div",
                                    [
                                      _vm.user.first_name
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                icon: "el-icon-edit"
                                              },
                                              on: {
                                                click: _vm.redirectToProfile
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("truncate")(
                                                    _vm.user.first_name,
                                                    15
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                icon: "el-icon-edit"
                                              },
                                              on: {
                                                click: _vm.redirectToProfile
                                              }
                                            },
                                            [_vm._v("My Account")]
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: { click: _vm.doLogout }
                                        },
                                        [_vm._v("Logout")]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-steps",
            { attrs: { active: _vm.active, "align-center": "" } },
            _vm._l(_vm.routes, function(config, route) {
              return _c("el-step", {
                attrs: { title: config.label },
                nativeOn: {
                  click: function($event) {
                    return (function(e) {
                      return _vm.clickHandler(e, route)
                    })($event)
                  }
                }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "container" },
            [_vm.getSessionStatus == "success" ? _c("router-view") : _vm._e()],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }